import MyButton from 'components/ui/Button/MyButton';
import React from 'react';
import { Link } from 'react-router-dom';
import PageNotFoundAsset from '../../assets/svg/404.svg';

const PageNotFound = () => {
    return (
        <div className='flex justify-center items-center flex-col gap-3 h-[80vh]'>
            <img src={PageNotFoundAsset} alt='Page Not Found' />
            <p style={styles.message}>Oops! Page Not Found</p>
            <p className='text-center'>
                Don’t worry, even the best employees take a wrong turn sometimes! <br /> 🚀 Let’s get you back on track.
            </p>
            <Link to={"/home"} style={styles.link}>
                <MyButton label='Back To Home' />
            </Link>
            <p className='text-center'>
                If the issue persists, contact our support team <br /> 
                at <a href="mailto:support@hrbuddie.com?subject=Support Request&body=Hi Team, I need help with..." className=' text-[#04B7B1] hover:text-[#04B7B1]'>
                    support@hrbuddie.com
                </a>
            </p>
        </div>
         )};

const styles = {
    container: {
        textAlign: 'center',
        padding: '50px',
        margin: "20dvh",
    },
    heading: {
        fontSize: '2.6dvw',
        color: '#333',
        marginBottom: '0.625dvw'
    },
    message: {
        fontSize: '1.5dvw',
        color: '#666',
        marginBottom: '0.625dvw'
    },
    image: {
        marginTop: '20px',
        maxWidth: '100%',
        height: 'auto',
    },
    link: {
        display: 'block',
        marginTop: '15px',
        marginBottom: '5px',
        fontSize: '1.3dvw',
        color: '#007BFF',
        textDecoration: 'none',
    },
};

export default PageNotFound;
